export default __webpack_public_path__ + "static/media/logo.1882884b.webp";